export const ADDRESS = 'address';
export const BROWSE = 'browse';
export const BUNDLES = 'bundles';
export const BUYLIST = 'buylist';
export const CHECKOUT = 'checkout';
export const CMS = 'cms';
export const COLLECTION = 'collection';
export const CUSTOM_AISLE = 'customAisle';
export const DELIVERY = 'delivery';
export const ENTERTAINING = 'entertaining';
export const FAVOURITES = 'favourites';
export const FORGOT_PASSWORD = 'forgot-password';
export const FOR_YOU = 'for-you';
export const QUICK_SHOP = 'quick-shop';
export const HOME = 'home';
export const INTERSTITIALS = 'interstitials';
export const LISTS = 'lists';
export const LOG_OUT = 'log-out';
export const MEAL_DEALS = 'mealDeals';
export const MISSED_OFFERS = 'missed-offers';
export const MULTI_SEARCH = 'multi-search';
export const MY_ORDERS = 'my-orders';
export const MY_WAITROSE = 'my-waitrose';
export const OFFERS = 'offers';
export const ORDER_CONFIRMATION = 'order-confirmation';
export const PAYMENT_CONFIRMATION = 'payment-confirmation';
export const RECIPES = 'recipes';
export const REGISTRATION = 'registration';
export const RESOLVE_PAYMENT = 'resolve-payment';
export const SEARCH = 'search';
export const SERVICE_SELECTION = 'service-selection';
export const SHOP_FROM_ORDER = 'shop-from-order';
export const SHOPPING_LISTS = 'shopping-lists';
export const TROLLEY = 'trolley';
export const VIEW_ORDER = 'view-order';
export const UNKNOWN = 'unknown';
